const KEYBOARD_KEY_CODES = {
  ARROW_DOWN: "ArrowDown",
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight",
  ARROW_UP: "ArrowUp",
  END: "End",
  ENTER: "Enter",
  ESC: "Escape",
  HOME: "Home",
  SPACE: "Space",
  TAB: "Tab"
};

export { KEYBOARD_KEY_CODES };
